/** Maps table column field to API sortBy parameter */
export const COLUMN_FIELD_TO_SORT = {
  externalId: 'externalId',
  employee: 'fullName',
  name: 'fullName',
  location: 'address.city',
  status: 'terminationDate',
  cif: 'cif',
  cifType: 'cifType',
};
